import { RefObject, useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { deliveryClientABC } from '../../api/cmsDeliveryClient';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { HeaderLayoutDetail } from '../../models';
import HomeBanner from '../../components/HomeBanner';
import { getHeaderCMSCodesWithMapping } from '../../utils/utilityfunctions';
import { getAccessCodeMappings } from '../../utils/accessCodeMappings';

export type ABCContextData = {
  headerData: any,
  setActiveTab: Function,
  selectedTab: string,
  containerRef: RefObject<HTMLDivElement>
};

const ABCLayout = () => {
  const [visibleSection, setVisibleSection] = useState<string>('welcome');
  let containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const updateActiveTab = (tab: string) => {
    setVisibleSection(tab);
  }
  const [contextDt, setContextDt] = useState<ABCContextData>({
    headerData: null,
    setActiveTab: updateActiveTab,
    selectedTab: 'welcome',
    containerRef: containerRef
  });

  useEffect(() => {
    const userdetails = localStorage.getItem('userdetail');
    if (!userdetails) {
      navigate("/");
    }
    else {
        // CMS-driven: fetch header codes including reporting access from access_code_mapping
        getHeaderCMSCodesWithMapping(getAccessCodeMappings, deliveryClientABC).then((codes) => {
          deliveryClientABC.items()
          .anyFilter('elements.user_access__access_code', codes)
          .toPromise()
          .then(
            response => {
              const updatedHeaderData: ABCContextData = {
                headerData: response.data.items.filter((i) => i.system.type === 'header_layout_detail') as HeaderLayoutDetail[],
                setActiveTab: updateActiveTab,
                selectedTab: 'welcome',
                containerRef: containerRef
              }
              setContextDt(updatedHeaderData);
            }
          )
        });
    }
  }, []);

  const updateSelectedTab = (tab: string) => {
    const updatedHeaderData: ABCContextData = {
      headerData: contextDt.headerData,
      setActiveTab: updateActiveTab,
      selectedTab: tab,
      containerRef: containerRef
    }
    setContextDt(updatedHeaderData);
  }

  return (
    <>
      <div id='main-wrapper' ref={containerRef}>
        <Navbar navBarData = {contextDt.headerData} activetab={visibleSection} updateSelectedTab = {updateSelectedTab} />
        <div className='page-wrapper'>
          <div className='container-fluid'>
            {visibleSection !== 'reporting' &&
              <HomeBanner bannerData={contextDt.headerData} />}
            <Outlet context={contextDt} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ABCLayout;